import { render, staticRenderFns } from "./ConsuptionDetail.vue?vue&type=template&id=fa9f8d5c&"
import script from "./ConsuptionDetail.vue?vue&type=script&lang=js&"
export * from "./ConsuptionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports